module.exports = __webpack_public_path__ + "static/media/g1.2ccd06ec.jpeg";